import { createStyles } from '@mantine/core'

export const useStyles = createStyles(() => ({
	appLink: {
		color: 'inherit',
		textDecoration: 'none',
		'&:hover': {
			textDecoration: 'underline',
		},
	},
}))
